import { useEffect, useState } from 'react';
import type { Session } from 'next-auth';

let authenticatedSession: Session | null = null;
let pendingSession: Promise<Session | null> | null = null;

async function requestPublicSession(): Promise<Session | null> {
  if (authenticatedSession) return authenticatedSession;
  if (pendingSession) return pendingSession;

  pendingSession = fetch('/api/auth/session', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  })
    .then(response => response.ok ? response.json() : null)
    .then(session => {
      const valid = session?.user?.accessToken || session?.user?.userId || session?.user?.email;
      authenticatedSession = valid ? session : null;
      return authenticatedSession;
    })
    .catch(() => null)
    .finally(() => { pendingSession = null; });

  return pendingSession;
}

export default function usePublicSession() {
  const [session, setSession] = useState<Session | null>(authenticatedSession);
  const [loading, setLoading] = useState(!authenticatedSession);

  useEffect(() => {
    let active = true;
    void requestPublicSession().then(result => {
      if (!active) return;
      setSession(result);
      setLoading(false);
    });
    return () => { active = false; };
  }, []);

  return { session, user: session?.user || null, loading };
}
